import { Request } from '@konv/http'
import { UserStorage } from '../shared/tools/UserStorage';

export class AssetsAPI {

    static async request({ endpoint = ' ', method = 'GET', headers, query, data }) {
        return await Request.request({
            endpoint: endpoint,
            method: method,
            headers: headers,
            service: 'assets',
            ignoreVersion: true,
            params: query,
            data: data
        });
    }

    static async requestAuthenticated({ method = 'GET', query, data }) {
        return await AssetsAPI.request({
            headers: { 'Authorization': 'Bearer ' + UserStorage.getAccessToken() },
            method,
            query,
            data,
        });
    }

    static async PostAssets(data) {
      return await AssetsAPI.requestAuthenticated({
          endpoint: ` `,
          method: 'POST',
          data

      });
  }



}